import React, { Fragment } from 'react'
import {
  Typography, SpacerVertical, Separator, Grid, Frame
} from '@klarna/bubble-ui'
import styles from '../LegalText/LegalText.css'
import LegalLink from '../../../common/components/LegalLink'
import { Warning } from './Warning'

type RiskDisclaimerProps = {
  riskDesclaimerSource: string
  riskDesclaimerHeading: string
  riskDisclaimerSubHeading: string
  frameBackground: string
}

const RiskDisclaimer: React.FC<RiskDisclaimerProps> = ({
  riskDesclaimerHeading = '',
  riskDisclaimerSubHeading = '',
  riskDesclaimerSource = '',
  frameBackground = ''
}) => riskDesclaimerSource && (
  <Fragment>
    <style>{styles}</style>
    <SpacerVertical spaceToken= 'space.600' />
    <Separator>
      <Typography colorToken="colors/text/neutral" textToken="text-style/text/labels/default/regular">
        {riskDesclaimerSource}
      </Typography>
    </Separator>
    <SpacerVertical spaceToken= 'space.300' />

    <Frame backgroundColorToken={frameBackground} paddingToken={'space.200'}>
      <Grid margin={0}>
        <Grid.Item columnSpan={2} paddingTop={4}>
          <Warning/>
        </Grid.Item>
        <Grid.Item columnSpan={10}>
          <Typography colorToken="colors/text/neutral" textToken="text-style/text/labels/default/bold">
            {riskDesclaimerHeading}
          </Typography>
          <Typography textToken= 'text-style/text/super-paragraphs/tiny/regular' colorToken='colors/text/neutral'>
            <LegalLink textToken={'text-style/text/super-paragraphs/tiny/regular'}
              colorToken={'colors/text/accent'}
              legalText = {riskDisclaimerSubHeading}
              legalLinkText = {''}
              legalLink ={''} />
          </Typography>
        </Grid.Item>
      </Grid>
    </Frame>
  </Fragment>
)

export default RiskDisclaimer
